import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { key: 1 }

import { Timespending } from '@/app.context/workspace/Event';
import { EffortRmodel, Timeffort } from '@/app.context/workspace/persons/sunrises/effort.rmodel'
import { Direction, SegmentEnd } from '@/logic/_infra/_tech';
import TimelineFullSubClocksComponent from './TimelineFullSubClocksComponent.vue'
import TimelineSimpleSubClocksComponent from './TimelineSimpleSubClocksComponent.vue'



import dayjs from 'dayjs'
import utc  from 'dayjs/plugin/utc'
import { computed } from 'vue';
import {offset as offset_f, emits} from '@/components/Workspaces/persons/_spec/timeline/clock_timeline'


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineClocksComponent',
  props: {
    item: {},
    edge: {},
    offset: {}
  },
  emits: emits,
  setup(__props: any, { emit: __emit }) {


dayjs.extend(utc)



const props = __props

const emit = __emit

const edge = computed(()=>{

    if (props.edge == undefined) return null

    else return props.edge
})

const offset = offset_f(props)

function click(d: Direction, e: SegmentEnd, effort: EffortRmodel, timeffort: Timeffort | null, timespending: Timespending | null) {

    emit("click", d, e, effort, timeffort, timespending)
}

return (_ctx: any,_cache: any) => {
  return (_ctx.item.segment_value.timespan_ms != 0)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (!_ctx.item.isMultiItem())
          ? (_openBlock(), _createBlock(TimelineFullSubClocksComponent, {
              key: 0,
              onClick: click,
              item: _ctx.item,
              timeffort: null,
              timespending: _ctx.item.timespendingOrNull(),
              segment: _ctx.item.segment_value,
              offset: _unref(offset)
            }, null, 8, ["item", "timespending", "segment", "offset"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(dayjs)(_ctx.item.segment_value.timepoint).utcOffset(_unref(offset)).format("HH:mm")), 1),
              _createTextVNode(" - "),
              _createElementVNode("span", null, _toDisplayString(_unref(dayjs)(_ctx.item.segment_value.end()).utcOffset(_unref(offset)).format("HH:mm")), 1)
            ], 64))
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (!_ctx.item.isMultiItem())
          ? (_openBlock(), _createBlock(TimelineSimpleSubClocksComponent, {
              key: 0,
              onClick: click,
              item: _ctx.item,
              timepoint: _ctx.item.segment_value.timepoint,
              timeffort: null,
              edge: edge.value,
              offset: _unref(offset)
            }, null, 8, ["item", "timepoint", "edge", "offset"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(dayjs)(_ctx.item.segment_value.timepoint).utcOffset(_unref(offset)).format("HH:mm")), 1))
      ], 64))
}
}

})